import { RunningExperiments, useExperiments } from 'state/experiments';

export const useRewardsPageRedesignPhaseTwoExperiment = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.RewardsPageRedesignPhaseTwo, 'treatment', {
    skipExposureLogging,
  });
};
